import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['../not-authorized/not-authorized.component.css']
})
export class NotFoundComponent {

}
